import React, { useEffect, useState } from 'react';
import { Grid, InputLabel, FormControl, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, useMediaQuery, FormHelperText, Typography, Checkbox } from '@mui/material';
import styled, { inputImages, inputNumbers, inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../TitleBar';
import { Locations, Zones } from '../TitleList';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { fetchZoneData } from '../../Store/PHPSlice/zone';
import { selectlocationdata, selectZones } from '../Selectors/Master/OutwardSelectors';
import { fetchLocationData2, insertLocationEntry } from '../../Store/PHPSlice/LocationApi';

const LocationEntry = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        schlNm: '',
        dt: '',
        adrs: '',
        ph: '',
        user: '-',
        pass: '-',
        zone: '',
        schlcode: '',
        userId: userdata?.ID
    });
    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        // Add more mappings if needed
    };
    const dispatch = useDispatch();
    const zonedata = useSelector(selectZones);
    const locdata = useSelector(selectlocationdata);
    useEffect(() => {
        dispatch(fetchZoneData());
        dispatch(fetchLocationData2());
    }, [dispatch]);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });

    };

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };




    const isDesktop = useMediaQuery('(min-width:768px)');


    const fieldsecond = [
        { label: 'School Name', name: 'schlNm' },
        { label: 'School Code', name: 'schlcode' },
        { label: 'Contact', name: 'ph' },
        { label: 'Address', name: 'adrs' },
        { label: 'User Name', name: 'user' },
        { label: 'Password', name: 'pass' },
    ];


    const handleDepartmentNew = () => {
        window.open(`/new-department-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownlistDepartment = [
        {
            label: 'Zone',
            id: 'zone',
            options: zonedata?.data || [],
            value: formData.zone,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'zone', value: newValue ? newValue.ID : '' } }, 'zone'),
            getOptionLabel: (option) => option.zoneNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleDepartmentNew(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('zone'),
            handleDropdownClose: () => handleDropdownClose('zone'),
        }
        ,
        // {
        //     label: 'Location',
        //     id: 'locId',
        //     options: locdata?.data || [],
        //     value: formData.locId,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.ID : '' } }, 'locId'),
        //     getOptionLabel: (option) => option.locNm || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        //     handleAddNew: '',
        //     btnlabel: 'New',
        //     handleDropdownOpen: () => handleDropdownOpen('locId'),
        //     handleDropdownClose: () => handleDropdownClose('locId'),
        // }

    ];

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.schlNm === '') {
            alert('Please Enter School Name');
            return;
        }

        if (formData.schlcode === '') {
            alert('Please Enter School Code');
            return;
        }

        if (formData.zone === '') {
            alert('Please Select Zone');
            return;
        }

        if (formData.user === '') {
            alert('Please Enter User Name');
            return;
        }

        if (formData.pass === '') {
            alert('Please Enter Password');
            return;
        }
        // console.log(formData)
        dispatch(insertLocationEntry(formData))
            .unwrap()
            .then((result) => {
                console.log('POST request successful!', result);
                alert("School Added");
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error while making POST request:', error);
            });
    };

    return (
        <>
            <Titlebar data={Locations} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>School Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={1.2}>

                                {fieldsecond?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}


                                {
                                    dropdownlistDepartment && dropdownlistDepartment?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default LocationEntry;
